export default {
  namespaced: true,
  state: {
    state: [
      { name: '未選択', value: 0 },
      { name: '新規', value: 1 },
      { name: '保留上げ', value: 2 },
      { name: '書換', value: 3 },
      { name: '内容変更', value: 4 },
      { name: '引継', value: 5 }
    ],

    support: [
      { name: '未選択', value: 0 },
      { name: '獲得', value: 1 },
      { name: '逃し', value: 2 },
      { name: '断り', value: 3 },
      { name: 'APCXL', value: 4 },
      { name: 'ツブレ', value: 5 }
    ],

    missing_detail: [
      { name: '未選択', value: 0 },
      { name: 'エリア外', value: 1 },
      { name: '子嫌', value: 2 },
      { name: '予算', value: 3 },
      { name: 'バッティング', value: 4 },
      { name: '短期希望', value: 5 },
      { name: '指導範囲外', value: 6 },
      { name: '不通', value: 7 },
      { name: '話し込めず', value: 8 },
      { name: '父と相談', value: 9 }
    ],

    contact_later: [
      { name: '未選択', value: 0 },
      { name: 'OK', value: 1 },
      { name: 'NG', value: 2 },
      { name: '未連絡', value: 3 },
      { name: '再連絡', value: 4 },
      { name: '先探し', value: 5 }
    ],

    result: [
      { name: '未選択', value: 0 },
      { name: '契約', value: 1 },
      { name: 'のみ', value: 2 },
      { name: '保留', value: 3 },
      { name: 'ツブレ', value: 4 },
      { name: 'ズレ', value: 5 },
      { name: '再営業', value: 6 }
    ],

    ap_type: [
      { name: '未選択', value: 0 },
      { name: '体験希望', value: 1 },
      { name: '資料請求', value: 2 },
      { name: '問合わせ', value: 3 }
    ],

    medium: [
      { name: '未選択', value: 0 },
      { name: 'DM', value: 1 },
      { name: '貼紙', value: 2 },
      { name: 'HP', value: 3 },
      { name: '紹介', value: 4 },
      { name: 'TEL注', value: 5 },
      { name: 'TA', value: 6 },
      { name: 'その他', value: 7 },
      { name: '一括資料請求', value: 8 }
    ],

    shop_type: [
      { name: '未選択', value: 0 },
      { name: 'スーパー', value: 1 },
      { name: 'ドラッグストア', value: 2 },
      { name: '調剤薬局', value: 3 },
      { name: '100円ショップ', value: 4 },
      { name: '郵便局', value: 5 },
      { name: '銀行', value: 6 },
      { name: 'ディスカウントストア', value: 7 },
      { name: 'パン屋', value: 8 },
      { name: '病院', value: 9 },
      { name: 'コンビニ', value: 10 },
      { name: 'ラーメン・そば系', value: 11 },
      { name: 'その他飲食店', value: 12 },
      { name: '弁当屋', value: 13 },
      { name: '携帯ショップ', value: 14 },
      { name: 'クリーニング屋', value: 15 },
      { name: '本屋', value: 16 },
      { name: '個人商店', value: 17 },
      { name: '娯楽施設', value: 18 },
      { name: 'A', value: 19 },
      { name: 'B', value: 20 },
      { name: 'C', value: 21 },
      { name: 'D', value: 22 },
      { name: 'E', value: 23 },
      { name: 'F', value: 24 },
      { name: 'G', value: 25 },
      { name: 'H', value: 26 },
      { name: 'I', value: 27 },
      { name: 'J', value: 28 },
      { name: 'K', value: 29 },
      { name: 'L', value: 30 }
    ],

    hp_type: [
      { name: '未選択', value: 0 },
      { name: '自社', value: 1 },
      { name: 'リスティング', value: 2 }
    ],

    hp_browse: [
      { name: '未選択', value: 0 },
      { name: 'PC', value: 1 },
      { name: 'SmartPhone', value: 2 },
      { name: '両方', value: 3 },
      { name: '非閲覧', value: 4 }
    ],

    gender: [
      { name: '未選択', value: 0 },
      { name: '男', value: 1 },
      { name: '女', value: 2 }
    ],

    school_type: [
      { name: '未選択', value: 0 },
      { name: '公立', value: 1 },
      { name: '国立', value: 2 },
      { name: '私立', value: 3 },
      { name: 'その他', value: 4 }
    ],

    school_stage: [
      { name: '未選択', value: 0 },
      { name: '小学', value: 1 },
      { name: '中学', value: 2 },
      { name: '高校', value: 3 },
      { name: '幼稚園', value: 4 },
      { name: 'その他', value: 5 }
    ],

    grade: [
      { name: '未選択', value: 0 },
      { name: '1', value: 1 },
      { name: '2', value: 2 },
      { name: '3', value: 3 },
      { name: '4', value: 4 },
      { name: '5', value: 5 },
      { name: '6', value: 6 }
    ],

    dm_information: [
      { name: '未選択', value: 0 },
      { name: 'OK', value: 1 },
      { name: 'NG', value: 2 },
      { name: 'データ不備', value: 3 },
      { name: '転居', value: 4 }
    ],

    preferred_contact: [
      { name: '未選択', value: 0 },
      { name: '自宅', value: 1 },
      { name: '携帯', value: 2 },
      { name: '勤務先', value: 3 },
      { name: 'その他', value: 4 },
      { name: 'SMS', value: 5 }
    ],

    contact_method: [
      { name: '未選択', value: 0 },
      { name: 'TEL', value: 1 },
      { name: 'MAIL', value: 2 },
      { name: 'その他', value: 3 }
    ],

    next_contact_method: [
      { name: '未選択', value: 0 },
      { name: 'TEL', value: 1 },
      { name: 'Eメール', value: 2 },
      { name: 'SMS', value: 3 },
      { name: 'DM', value: 4 }
    ],

    contact_person: [
      { name: '未選択', value: 0 },
      { name: '母 ', value: 1 },
      { name: '父', value: 2 },
      { name: '祖母', value: 3 },
      { name: '祖父', value: 4 },
      { name: '本人', value: 5 },
      { name: '伯母', value: 6 },
      { name: '伯父', value: 7 }
    ],

    parking: [
      { name: '未選択', value: 0 },
      { name: '有', value: 1 },
      { name: '無', value: 2 }
    ],

    learning_result: [
      { name: '未選択', value: 0 },
      { name: '上がった', value: 1 },
      { name: '下がった', value: 2 },
      { name: '変わらない', value: 3 },
      { name: 'わからない', value: 4 }
    ],

    learning_continuation: [
      { name: '未選択', value: 0 },
      { name: '継続する', value: 1 },
      { name: '継続しない', value: 2 },
      { name: 'わからない', value: 3 }
    ],

    fathers_involvement: [
      { name: '未選択', value: 0 },
      { name: '有', value: 1 },
      { name: '無', value: 2 }
    ],

    notices: [
      { name: '未選択', value: 0 },
      { name: '郵送・FAX/予定日', value: 1 },
      { name: 'バッティング', value: 2 },
      { name: '不登校', value: 3 },
      { name: '障害', value: 4 }
    ],

    sending_products: [
      { name: '未選択', value: 0 },
      { name: '体験案内', value: 1 },
      { name: '資料', value: 2 },
      { name: '料金表', value: 3 },
      { name: 'Quoカード', value: 4 },
      { name: 'ギフトカード', value: 5 },
      { name: 'キャンペーンチラシ', value: 6 },
      { name: '送らない', value: 7 }
    ],

    sending_method: [
      { name: '未選択', value: 0 },
      { name: '郵送', value: 1 },
      { name: 'FAX', value: 2 },
      { name: 'MAIL', value: 3 },
      { name: '持っていく', value: 4 }
    ],

    maru: [
      { name: '', value: 0 },
      { name: '○', value: 1 }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    state (state) { return state.state },
    support (state) { return state.support },
    missing_detail (state) { return state.missing_detail },
    contact_later (state) { return state.contact_later },
    result (state) { return state.result },
    ap_type (state) { return state.ap_type },
    medium (state) { return state.medium },
    shop_type (state) { return state.shop_type },
    hp_type (state) { return state.hp_type },
    hp_browse (state) { return state.hp_browse },
    gender (state) { return state.gender },
    school_type (state) { return state.school_type },
    school_stage (state) { return state.school_stage },
    grade (state) { return state.grade },
    dm_information (state) { return state.dm_information },
    preferred_contact (state) { return state.preferred_contact },
    contact_method (state) { return state.contact_method },
    next_contact_method (state) { return state.next_contact_method },
    contact_person (state) { return state.contact_person },
    parking (state) { return state.parking },
    learning_result (state) { return state.learning_result },
    learning_continuation (state) { return state.learning_continuation },
    fathers_involvement (state) { return state.fathers_involvement },
    notices (state) { return state.notices },
    sending_products (state) { return state.sending_products },
    sending_method (state) { return state.sending_method },
    maru (state) { return state.maru }
  }
}



// WEBPACK FOOTER //
// ./src/store/appointments.js